import { NgStyle } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  ElementRef,
  HostBinding,
  input,
  Input,
  QueryList,
  ViewChildren,
  ViewEncapsulation,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { SliderModule } from 'primeng/slider';
import { CoreControlDirective } from '../../../utils/core-control.directive';

@Component({
  selector: 'osp-slider',
  templateUrl: './slider.component.html',
  styleUrl: './slider.component.scss',
  standalone: true,
  imports: [SliderModule, ReactiveFormsModule, NgStyle],
  providers: CoreControlDirective.coreControlProvider(SliderComponent),
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SliderComponent extends CoreControlDirective {
  @HostBinding('class.osp-slider') protected hostCssClassEnabled = true;

  @ViewChildren('sliderHandle') sliderHandles!: QueryList<ElementRef>;

  @Input() min?: number;
  @Input() max?: number;
  @Input() step?: number;
  @Input() range = false;
  @Input() orientation: 'vertical' | 'horizontal' = 'horizontal';
  @Input() tabindex?: number;
  @Input() cssClass = '';
  $labelsSuffix = input('', { alias: 'labelsSuffix' });
  $tooltipCallback = input<(value: number) => string>((value) => `${value}${this.$labelsSuffix()}`, {
    alias: 'tooltipCallback',
  });

  $tooltipText = computed(() => this.$tooltipCallback()(this.$controlValue() as number));
  $tooltipShiftPercent = computed(() => {
    const sliderLength = (this.max ?? 0) - (this.min ?? 0);
    const currentPoint = (this.$controlValue() as number) - (this.min ?? 0);
    return (currentPoint / sliderLength) * 100;
  });
}
